import {defineStore} from 'pinia'
import {useAuthStore} from "@/stores/auth";
import {mainAxios} from "@/main";
import {useApiSettingStore} from "@/stores/apiSettings";


export const useSettings = defineStore({
    id: 'settings',

    state: () => ({
        loading: null,
        addSetting: false,
        settings: null,
        serviceAccountCredentials: {},
        systemSettings: {},
        setting: null,
        optionsSettings: null,
        checkAudioStatus: false,
        messages: []
    }),
    actions: {
        getSettings(payload) {
            return new Promise((resolve, reject) => {

                let url = new URL(mainAxios.defaults.baseURL + 'api/settings/')

                if (payload.queryParams !== null) {
                    let params = new URLSearchParams()
                    for (let i = 0; i < Object.keys(payload.queryParams).length; i++) {
                        params.set(Object.keys(payload.queryParams)[i], Object.values(payload.queryParams)[i])
                    }
                    params.set('key__in', 'avatar_settings')
                    url.search = params
                    mainAxios.get(url.pathname + url.search)
                        .then(res => {
                            this.settings = res.data
                            res.data.results[0].setting_records.forEach(setting => {
                                this.systemSettings[setting.key] = {
                                    "value": setting.value,
                                    "choices": setting.choices ? setting.choices.choices : null
                                }
                            })
                            resolve(res)
                        })
                        .catch(err => {
                            if (err.response && err.response.status === 500) {
                                useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                            }
                            reject(err)
                        })
                } else {
                    let params = new URLSearchParams()
                    params.set('key__in', 'avatar_settings')
                    url.search = params
                    mainAxios.get(url.pathname + url.search)
                        .then(res => {
                            res.data.results[0].setting_records.forEach(setting => {
                                this.systemSettings[setting.key] = {
                                    "value": setting.value,
                                    "choices": setting.choices ? setting.choices.choices : null
                                }
                            })
                            this.settings = res.data
                            resolve(res)
                        })
                        .catch(err => {
                            if (err.response && err.response.status === 500) {
                                useApiSettingStore().error500 = 'Qualcosa non ha funzionato, riprova'
                            }
                            reject(err)
                        })
                }
            })
        },
        getServiceAccountCredentials() {
            return new Promise((resolve, reject) => {
                const config = {
                    headers: {
                        Authorization: 'Token ' + useAuthStore().userGetters.token
                    }
                }
                let params = new URLSearchParams()
                params.append('key__in', 'service_account_backoffice')
                mainAxios.get('api/settings/?' + params,config)
                    .then(res => {
                        if (res.data.results.length > 0) {
                            this.serviceAccountCredentials = res.data.results[0]
                            let settings_records = {}
                            res.data.results[0].setting_records.forEach(setting => {
                                settings_records[setting.key] = {
                                    "value": setting.value,
                                    "choices": setting.choices ? setting.choices.choices : null
                                }
                            })
                            this.serviceAccountCredentials['setting_records'] = settings_records
                        }
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        deleteSetting(payload) {
            return new Promise((resolve, reject) => {
                const config = {
                    headers: {
                        Authorization: 'Token ' + useAuthStore().userGetters.token
                    }
                }
                mainAxios.delete('api/settings/' + payload + '/', config)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })

            })
        },
        getSetting(payload) {
            return new Promise((resolve, reject) => {
                const config = {
                    headers: {
                        Authorization: 'Token ' + useAuthStore().userGetters.token
                    }
                }
                mainAxios.get('api/settings/' + payload + '/', config)
                    .then(res => {
                        this.setting = res.data
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })

            })
        },
        editSetting(payload) {
            return new Promise((resolve, reject) => {
                const config = {
                    headers: {
                        Authorization: 'Token ' + useAuthStore().userGetters.token
                    }
                }
                mainAxios.patch('api/settings/' + payload.id + '/', payload, config)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })

            })
        },
        getOptionsSettings() {
            return new Promise((resolve, reject) => {
                const config = {
                    headers: {
                        Authorization: 'Token ' + useAuthStore().userGetters.token
                    }
                }
                mainAxios.options('api/settings/', config)
                    .then(res => {
                        this.optionsSettings = res.data
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })

            })
        },
        createSetting(payload) {
            return new Promise((resolve, reject) => {
                const config = {
                    headers: {
                        Authorization: 'Token ' + useAuthStore().userGetters.token
                    }
                }
                mainAxios.post('api/settings/', payload, config)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })

            })
        }
    },

    getters: {
        settingsGetters: state => {
            return state.settings
        },
        systemSettingsGetters: state => {
            return state.systemSettings
        },
        settingGetters: state => {
            return state.setting
        },
        optionsSettingsGetters: state => {
            return state.optionsSettings
        },
        addSettingGetters: state => {
            return state.addSetting
        },
        loadingGetters: state => {
            return state.loading
        },
        messagesGetters: state => {
            return state.messages
        },
        checkAudioStatusGetters: state => {
            return state.checkAudioStatus
        },
        serviceAccountCredentialsGetters: state => {
            return state.serviceAccountCredentials
        }
    }
})


